import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { VerrouPosteAdmin } from '../services/verrou-poste';

/** Code HTTP 423 « Locked » : la requete n'est pas partie, le poste est verrouille. */
export const STATUT_POSTE_VERROUILLE = 423;

/**
 * Un poste verrouille n'appelle aucune API. Premier de la chaine : la requete est refusee AVANT que le
 * jeton soit lu ou ajoute, et l'erreur n'est pas un 401 — `authInterceptor` ne deconnecte donc pas.
 * Les ressources locales (`assets/`) passent : elles servent l'ecran de verrou lui-meme.
 */
export const verrouInterceptor: HttpInterceptorFn = (req, next) => {
  const local = req.url.startsWith('./assets/') || req.url.startsWith('/assets/') || req.url.startsWith('assets/');
  if (local || !inject(VerrouPosteAdmin).verrouille()) return next(req);
  return throwError(
    () => new HttpErrorResponse({ url: req.url, status: STATUT_POSTE_VERROUILLE, statusText: 'Poste verrouille' }),
  );
};
